export default "__VITE_ASSET__07fc221d__"